import { useDispatch } from "react-redux";

import { CmmOrderTableRowData } from "../../../../data-model/cmmOrderTableRowData";

import { setOpenedModalId } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";
import EyeIcon from "../../../../svg/eye";

interface InternalChildCardMedicalProps {
  title: string;
  showPrimaryDescription?: boolean;
  primaryDescription: string[];
  secondaryDescription: string[];
  showIcon?: boolean;
  modalId?: string;
  rowData?: CmmOrderTableRowData;
}

const InternalChildCardMedical = ({
  title,
  primaryDescription,
  secondaryDescription,
  showIcon,
  modalId,
  rowData,
  showPrimaryDescription,
}: InternalChildCardMedicalProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleEyeIconClick = () => {
    if (modalId) {
      dispatch(setOpenedModalId({ id: modalId }));
    }
  };

  return (
    <div className={`flex w-3/4 flex-col gap-2 p-3`}>
      <div className="flex flex-col gap-1 text-sm">
        <div className="flex flex-row items-center gap-2">
          <div className="font-bold">{title}</div>

          {showIcon && <EyeIcon onClick={handleEyeIconClick} />}
        </div>
        {showPrimaryDescription && (
          <div
            className={`max-w-[40ch] truncate text-primaryGray-6`}
            title={primaryDescription.join(" - ")}
            dangerouslySetInnerHTML={{
              __html: primaryDescription.join(" &#8226; "),
            }}
          />
        )}
      </div>
      <div
        className="max-w-[40ch] truncate text-sm"
        title={secondaryDescription.slice(0, 3).join(" - ")}
        dangerouslySetInnerHTML={{
          __html: secondaryDescription.join(" &#8226; "),
        }}
      />
    </div>
  );
};

export default InternalChildCardMedical;
